/* eslint-disable no-nested-ternary */
import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { login } from "@/actions/auth";
import { Button, Form, Input } from "antd";
import Language from "@/components/Common/Language";
import intl from "react-intl-universal";
import logoImg from "@/assets/image/logo.png";
import styles from "./Login.module.scss";

type FieldType = {
  email?: string;
  password?: string;
};

const Login = (props) => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      await props.login({ ...values });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.content}>
        <div className={styles.contentForm}>
          <div className={styles.langBox}>
            <Language />
          </div>
          <div className={styles.title}>
            <img src={logoImg} alt="" />
            {intl.get("login_title")}
          </div>
          <div className={styles.tips}>
            {intl.get("login_no_account")}
            <span
              onClick={() => {
                window.location.href = "/register";
              }}
            >
              {intl.get("login_create_account")}
            </span>
          </div>
          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
            onFinish={onFinish}
            layout="vertical"
            autoComplete="off"
          >
            <Form.Item<FieldType>
              name="email"
              label={intl.get("login_email")}
              rules={[
                {
                  required: true,
                  message: intl.get("login_email_placeholder"),
                },
              ]}
            >
              <Input
                className={styles.loginIuput}
                // prefix={<UserOutlined />}
                placeholder={intl.get("login_email_placeholder")}
                autoComplete="off"
                readOnly={loading}
                allowClear
              />
            </Form.Item>

            <Form.Item<FieldType>
              name="password"
              label={intl.get("login_password")}
              rules={[
                {
                  required: true,
                  message: intl.get("login_password_placeholder"),
                },
              ]}
            >
              <Input.Password
                className={styles.loginIuput}
                // prefix={<LockOutlined />}
                placeholder={intl.get("login_password_placeholder")}
                autoComplete="off"
                readOnly={loading}
                allowClear
              />
            </Form.Item>
            <div className={styles.wjPwdButton}>
              <Button
                type="link"
                onClick={() => {
                  window.location.href = "/password";
                }}
              >
                {intl.get("login_forget_password")}
              </Button>
            </div>
            <Button
              className={styles.loginButton}
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              {intl.get("login_btn")}
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default withRouter(connect(null, { login })(Login));
